import * as React from 'react';
import * as w from '@packages/systems/wfdl';
import * as wast from '@packages/systems/wfdl-ast';

import RequestInput from './RequestInput';

const tooltipText =
  'Credentials store your verification details for easy authentication.';

export const RequestAuthenticationHeaderType = w.TypeImplementation.Alias({
  type: w.withMeta({placeholder: 'E.g. x-api-token'}, wast.TText),
  render: function RenderRequestAuthenticationHeader({expr, dispatch}) {
    return (
      <RequestInput
        label="Header"
        tooltipText={tooltipText}
        expr={expr}
        dispatch={dispatch}
        required
      />
    );
  },
});
